import Ajax from './ajax';
import { cloneDeep } from 'lodash';
import PricingRule from '../domain/pricingrule';

export const PRICING_RULE_SAVED = 'cppricing/PRICING_RULE_SAVED';
export const PRICING_RULES_RETRIEVED = 'cppricing/PRICING_RULES_RETRIEVED';
export const PRICING_RULES_GET_PENDING = 'cppricing/PRICING_RULES_GET_PENDING';
export const PRICING_RULE_DELETED = 'cppricing/PRICING_RULE_DELETED';

const initialState = {
    pricingRules: null,
    fetchingData: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case PRICING_RULE_SAVED: {
            const newRules = cloneDeep(state.pricingRules);
            const existingIndex = newRules.findIndex((r) => r.id === action.newOrEditedRule.id);

            if (existingIndex >= 0) {
                newRules[existingIndex] = new PricingRule(action.newOrEditedRule);
            } else {
                newRules.push(new PricingRule(action.newOrEditedRule));
            }
            return { ...state, pricingRules: newRules };
        }
        case PRICING_RULES_RETRIEVED: {
            const newRules = [];
            for (const r of action.rules) {
                newRules.push(new PricingRule(r));
            }
            return { ...state, fetchingData: false, pricingRules: newRules };
        }
        case PRICING_RULES_GET_PENDING: {
            return { ...state, fetchingData: true };
        }
        case PRICING_RULE_DELETED: {
            const newRules = cloneDeep(state.pricingRules).filter((r) => r.id !== action.deletedId);
            return { ...state, pricingRules: newRules };
        }
        default:
            return state;
    }
};

export const getPricingRules = () => {
    return async (dispatch) => {
        dispatch({
            type: PRICING_RULES_GET_PENDING,
        });
        const resp = await Ajax.get('api/contractprice/pricingrules');
        dispatch({
            type: PRICING_RULES_RETRIEVED,
            rules: resp.data,
        });
    };
};

export const savePricingRule = (rule) => {
    return async (dispatch) => {
        const resp = await Ajax.put('api/contractprice/pricingrule', rule);
        dispatch({
            type: PRICING_RULE_SAVED,
            newOrEditedRule: resp.data,
        });
    };
};

export const deletePricingRule = (ruleId) => {
    return async (dispatch) => {
        await Ajax.delete(`api/contractprice/pricingrule/${ruleId}`);
        dispatch({
            type: PRICING_RULE_DELETED,
            deletedId: ruleId,
        });
    };
};
